import React from 'react'
import { format } from 'date-fns'

const longDateFormat = "EEEE, MMMM do, yyyy"

const ConfirmationPage = ({ userAppointmentCalendar, selectedDate, selectedTime, meetingDetails }) => {
  if(!userAppointmentCalendar) {
    return null
  }

  const formattedDate = format(selectedDate, longDateFormat)

  return (
    <div className="appointment-scheduler-confirmation">
      <div className="appointment-scheduler-confirmation-title mb-3">
        Your appointment has been scheduled
      </div>

      <div className="mt-3">
        <div dangerouslySetInnerHTML={{ __html: userAppointmentCalendar.attributes.confirmationMessageHtml }} />
      </div>

      <div className="card">
        <div className="card-body">
          <div>{ userAppointmentCalendar.attributes.fullName }</div>
          <div>{ formattedDate } at { selectedTime }</div>
          <div className="appointment-scheduler-overview-meta">{ userAppointmentCalendar.attributes.location }</div>
          <hr />
          <div>Meeting Details will be sent to:</div>
          <div>{ meetingDetails.guestName } &lt;{ meetingDetails.guestEmail}&gt;</div>
          <div>{ meetingDetails.additionalGuests }</div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationPage
